import { useLinkProps } from '@react-navigation/native';
import type { FC, PropsWithChildren } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import { Pressable, StyleSheet } from 'react-native';

import type {
  NavigationItemProps,
  AppRoute
} from '@/navigation/types/navigation';

type Props = PropsWithChildren<
  NavigationItemProps & {
    accessibilityLabel?: string;
    accessibilityHint?: string;
    overlay?: boolean;
    style?: StyleProp<ViewStyle>;
  }
>;

const styles = StyleSheet.create({
  link: { cursor: 'pointer' }
});

export const OverlayLink: FC<Props> = ({
  screen,
  params,
  action,
  href,
  accessibilityLabel,
  accessibilityHint,
  overlay = false,
  style,
  children
}) => {
  const linkProps = useLinkProps<AppRoute>({
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    screen,
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    params,
    action,
    href
  });

  return (
    <Pressable
      {...linkProps}
      accessibilityLabel={accessibilityLabel}
      accessibilityHint={accessibilityHint}
      style={[overlay && StyleSheet.absoluteFill, styles.link, style]}
    >
      {children}
    </Pressable>
  );
};
